import React, { useState, useEffect } from 'react';

import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle, Modal, ModalBody } from 'reactstrap';

//import images
import avatar1 from "../../Assets/Images/profile/defaultProfile2.jpg";

import { useTranslation } from "react-i18next";


const CompHeaderProfileDropdown = () => {

    const { t } = useTranslation();

    const [userName, setUserName] = useState("Admin");
    const [userProfilePhotoUrl, setProfilePhotoUrl] = useState("Admin");
    const [userOrganizationName, setOrganizationName] = useState("Admin");
    const [userEmail, setUserEmail] = useState("Admin");
    const [tenants, setTenants] = useState([]);

    useEffect(() => {

        if ((sessionStorage.getItem("currentSession") !== null && sessionStorage.getItem("currentSession")?.bearerToken !== '') || true) {
            let user = sessionStorage.getItem("currentSession");
            
            const obj = JSON.parse(user);
            setUserName(user.firstName || obj.firstName + " " + obj.lastName || "Admin");
            setProfilePhotoUrl(user.image || obj.image || avatar1);
            setOrganizationName(('app:\\' + obj.application.id?.toLowerCase() + '\\' + obj.session.id));
            setUserEmail(obj.email);
            setTenants(obj.tenants || []);

        }

    }, []);

    const [changePasswordModal, setChangePasswordModal] = useState(false);
    const onGoToChangePassword = props => {
        setChangePasswordModal(true);
    };

    const onGoToChangeDomain = props => {
        //history.push("/change-domain");
    };

    const handleCloseTask = () => {
        setChangePasswordModal(false);
    };

    const handleStartTask = () => {
        console.log(userEmail);
        setChangePasswordModal(false);
        let values = {
            email: userEmail
        };

        //history.push("/change-password");
    };


    //Dropdown Toggle
    const [isProfileDropdown, setIsProfileDropdown] = useState(false);
    const toggleProfileDropdown = () => {
        setIsProfileDropdown(!isProfileDropdown);
    };

    const callLogout = (btn) => {
        //sessionStorage.removeItem("currentSession");
        //setSeed(Math.random());
        //Navigate('/logout');
        let redirectUrl = '/logout';
        window.location.href = redirectUrl;
    };

    return (
        <React.Fragment>
            <Modal isOpen={changePasswordModal} centered={true} size="lg">
                <ModalBody className="py-3 px-5">
                    <div className="mt-2 text-center">
                        <lord-icon
                            src="https://cdn.lordicon.com/gsqxdxog.json"
                            trigger="loop"
                            colors="primary:#FFBC0A,secondary:#f06548"
                            style={{ width: "100px", height: "100px" }}
                        ></lord-icon>
                        <div className="mt-4 pt-2 fs-15 mx-4 mx-sm-5">
                            <h4>{t('ChangePassword.Layout.Modal.Title')}</h4>
                            <p className="text-muted mx-4 mb-0">
                                {t('ChangePassword.Layout.Modal.Message')}
                            </p>
                        </div>
                    </div>
                    <div className="d-flex gap-2 justify-content-center mt-4 mb-2">
                        <button
                            type="button"
                            className="btn w-sm btn-light"
                            data-bs-dismiss="modal"
                            onClick={handleCloseTask}
                        >
                            {t('ChangePassword.Layout.Modal.Button.Cancel')}
                        </button>
                        <button
                            type="button"
                            className="btn w-sm btn-primary "
                            id="delete-record"
                            onClick={handleStartTask}
                        >
                            {t('ChangePassword.Layout.Modal.Button.Send')}
                        </button>
                    </div>
                </ModalBody>
            </Modal>
            <Dropdown isOpen={isProfileDropdown} toggle={toggleProfileDropdown} className="ms-sm-3 header-item topbar-user">
                <DropdownToggle tag="button" type="button" className="btn">
                    <span className="d-flex align-items-center">
                        <img className="rounded-circle header-profile-user" width={40} height={40} src={userProfilePhotoUrl}
                            alt="Header Avatar" />
                        <span className="text-start ms-xl-2">
                            <span className="d-xl-inline-block ms-1 fw-bold user-name-text text-dark bold">{userName}</span>
                            <span className="d-none d-xl-block ms-1 fs-12 user-name-sub-text text-dark">{userOrganizationName}</span>
                        </span>
                    </span>
                </DropdownToggle>
                <DropdownMenu className="dropdown-menu-end">

                    <h6 className="dropdown-header">{t('navbar.navitem.welcome.prefix')} {userName}!</h6>
                    <DropdownItem onClick={e => { callLogout(e) }}><i
                        className="mdi mdi-logout text-muted fs-16 align-middle me-1"></i> <span
                            className="align-middle" data-key="t-logout">{t('navbar.navitem.logout')}</span></DropdownItem>
                </DropdownMenu>
            </Dropdown>
        </React.Fragment>
    );
};

export default CompHeaderProfileDropdown;